import { DBO_TM } from '@op/utils/format';
import moment from 'moment';
export const defaultFilterValue = (defaultObj: any = {}) => ({
  channel_comments: [],
  channel_news: [],
  channel_securitys: [],
  channel_social: [],
  date_type: 'daily',
  ...DBO_TM.filterToday('daily'),
  keyword_en: [],
  is_valid: [],
  language: [],
  social_media_by_keyword: [],
  social_media_by_account: [],
  external_data_sources: [],
  exclude_channels: [],
  platform: [],
  reviews_rating: [],
  logic: 'and',
  affinity_type: 'and',
  region_type: 'region',
  region: [],
  sentiment: [],
  sentiment_clause: [],
  sub_topic_sentiment: [],
  topic: [],
  version: [],
  version_times: [],
  refunded: 0,
  free_played: 0,
  starred_tag: 0,
  early_access: 0,
  steam_purchase: 0,
  steam_ids: [],
  funnys: [],
  helpfuls: [],
  keyword: [],
  keyWords: [],
  keyword_filter_types: [],
  data_source: [],
  game_type: [],
  channel_type_select: [],
  video_labels: [],
  reviewers: [],
  engagements: [],
  followers: [],
  likes: [],
  comments: [],
  shares: [],
  review_types: [],
  matched_type: '-',
  live_venues: [],
  officials: [],
  record_times: [],
  review_times: [],
  avg_engagements_rate: [],
  avg_brand_views: [],
  avg_views: [],
  views: [],
  publications: [],
  brand_publications: [],
  game_covereds: [],
  game_affinitys: [{ end_affinity: 0, sign: '>=' }],
  brand_affinitys: [{ end_affinity: 0, sign: '>=' }],
  news_data_source: [],
  news_beat: [],
  news_coverage_type: [],
  uvpm: [],
  games: ['99999'],
  monitor_scource: [],
  topic_rule: 'include',
  topicType: 'all_topic',
  kol_tags: [],
  video_types: [],
  compare_games: [],
  perspective_type: 'category',
  keywordActiveId: 'custom',
  like_math_exclude_keywords: [],
  like_math_keywords: [],
  content_urls: [],
  sentiment_edit_status: '99999',
  intent: [],
  selected_games: [],
  key_kols: [],
  posts: [],
  game_product_ids: [],
  organization: '-',
  keywords_list: [],
  include_comments_of_matched_posts: false,
  kol_countrys: [],
  video_tags: [],
  monitor_source_match_mode: 'include',
  keywords_list_mode: "include",
  zone_games: [],
  account_categories: [],
  black_gray_author_filter: [],
  aigc: 0,
  ...defaultObj,
});

export const FilterItemClassName = 'filter-common-item';

function splitTextFunc(value: string) {
  if (value?.toLocaleLowerCase() === 'all') {
    return [];
  }
  return value?.split(',') || [];
}
function commonTextFunc(value: string) {
  return value;
}
function formatTimeTextFunc(value: string) {
  const formatValue = moment(value).format('YYYY-MM-DD HH:mm:ss');
  if (formatValue === 'Invalid date') {
    return null;
  }
  return formatValue;
}
function splitTextWithFormatNumberFunc(value: string) {
  return splitTextFunc(value).map(Number);
}

function splitTextWithCurrentTime(value: string) {
  const [start_time, end_time] = splitTextFunc(value).map(formatTimeTextFunc);
  return {
    _flag: true,
    start_time,
    end_time,
  };
}

function commonTextDateTypeFunc(value: string) {
  return {
    _flag: true,
    date_type: value,
  };
}

export const urlParamsFormatMap: { [key: string]: any } = {
  start_time: formatTimeTextFunc,
  end_time: formatTimeTextFunc,
  date_type: commonTextFunc,
  channel_social: splitTextFunc,
  channel_comments: splitTextFunc,
  channel_news: splitTextFunc,
  channel_securitys: splitTextFunc,
  channel_type: commonTextFunc,
  channel: splitTextFunc,
  region_type: commonTextFunc,
  region: splitTextFunc,
  social_media_by_keyword: splitTextFunc,
  social_media_by_account: splitTextFunc,
  is_valid: splitTextWithFormatNumberFunc,
  language: splitTextFunc,
  sentiment: splitTextWithFormatNumberFunc,
  topic: splitTextFunc,
  reviews_rating: splitTextFunc,
  currentTime: splitTextWithCurrentTime,
  dateType: commonTextDateTypeFunc,
  monitor_scource: splitTextWithFormatNumberFunc,
  content_urls: splitTextFunc,
  review_types: splitTextFunc,
};
// start_time=2023-10-16
// end_time=2023-10-16
// date_type=daily
// channel=all
// topic=all
// hero=all
// sentiment=all
// reviews_rating=all
export const setUrlParamsKeys = [
  'start_time',
  'end_time',
  'date_type',
  'channel_social',
  'channel_comments',
  'channel_news',
  'channel_securitys',
  'channel_type',
  'channel',
  'topic',
  'sentiment',
  'reviews_rating',
  // 'region_type',
  // 'region',
  // 'social_media_by_keyword',
  // 'social_media_by_account',
  // 'is_valid',
  // 'language',
];

export enum FILTER_CONST {
  THAN_RANGE_CUSTOMIZE = 'interval',
}
